class ProductUpsell extends HTMLElement {

    constructor() {
      super();
      this.select_dropdowns = this.querySelectorAll(".upsell-select");
      this.selected_id = null;
      this.atc_buttons = this.querySelectorAll(".upsell-atc");
      this.upsell_form = this.querySelector("#upsell-form");
      this.errorMessages = this.querySelectorAll(".product-upsell__error");
    }

    connectedCallback() {
        /* Functions */
        const enableATC = (product_id) => {
            this.atc_buttons.forEach((atc_button)=> {
                atc_button.removeAttribute('disabled');
                atc_button.innerHTML = '<span>Add To Cart</span>';
                atc_button.setAttribute('data-product-id', product_id);
            });
        }

        const disableATC = () => {
            this.atc_buttons.forEach((atc_button)=> {
                atc_button.setAttribute('disabled', true);
            });
        }

        const setErrorMessage = (errorMessage) => {
            if(errorMessage){
                this.errorMessages.forEach((errorElement)=> {
                    errorElement.innerHTML = `<span>${errorMessage} </span>`
                    errorElement.classList.add('product-upsell__error--active');
                })
            } else {
                this.errorMessages.forEach((errorElement)=> {
                    errorElement.innerHTML = ``;
                    errorElement.classList.remove('product-upsell__error--active');
                })
            }
        }

        const handleATC = (product_id) => {
            const miniCart = document.querySelector('#MiniCart');
            let formData = {
                'items': [{
                'id': product_id,
                'quantity': 1
                }]
            };
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                if(response.ok){
                    window.ajaxCart.load();
                    miniCart.classList.add("opened");
                } else {
                    /* Handle Error With Response Message */
                    response.json().then((data) => {
                        setErrorMessage(data.message);
                    });
                }
            })
            .catch(() => {
                setErrorMessage('Something went wrong. Please try again later.');
            });
        }

        const updateAllSelectors = (product_id) => {
            /* keeps the mobile & desktop versions in sync */
            this.select_dropdowns.forEach((selector) => {
                if(product_id != selector.value){
                    selector.value = product_id
                }
            })
        }

        /* Event Listners */
        this.select_dropdowns.forEach((selector)=> {
            selector.addEventListener("change", function(e) {
                this.selected_id = this.value;
                if(this.value != null){
                    enableATC(this.value);
                    updateAllSelectors(this.value);
                    setErrorMessage(false);
                }
            });
        });

        this.upsell_form.addEventListener("submit", (e) => {
            e.preventDefault();
            const product_id = e.submitter.dataset.productId;
            if(product_id){
                handleATC(product_id)
            }
        });

        this.atc_buttons.forEach((button)=> {
            button.addEventListener("click"), function(e) {
                e.preventDefault();
                //return if disabled;
                handleATC();
            }
        });
    }
  }

if (!customElements.get("product-upsell")) {
    customElements.define("product-upsell", ProductUpsell);
}
